import CarCard from './CarCard';
import '../AllCss/MostViewedCarousel.css';

const DISPLAY_COUNT = 4;

function MostViewedCarousel({ cars, title = 'Most Viewed Cars in Our Lot' }) {
  const displayCars = (cars || []).slice(0, DISPLAY_COUNT);

  if (displayCars.length === 0) {
    return null;
  }

  return (
    <div className="most-viewed-carousel">
      <div className="carousel-header">
        <h2 className="carousel-title">{title}</h2>
      </div>

      <div className="most-viewed-grid">
        {displayCars.map((car) => (
          <CarCard key={car.id} car={car} />
        ))}
      </div>
    </div>
  );
}

export default MostViewedCarousel;
